var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prominent-button",class:[_vm.color,{subActive:_vm.subActive}],on:{"click":function($event){return _vm.onclick()}}},[_c('i',{staticClass:"leading-icon",class:_vm.leadingIcon}),_c('button',[_vm._v(" "+_vm._s(_vm.$t(_vm.textLabel))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }